import {PlayerConferenceData} from "../../types";

/**
 * Модель участника конференции
 */
export default class ConferenceParticipant {

    /**
     * Данные игрока
     * @protected
     */
    protected playerData: PlayerConferenceData;

    /**
     * Constructor
     * @param {string} gameId
     */
    constructor(gameId: string)
    {
        let dataFromStorage = localStorage.playerConferenceData;

        if (typeof dataFromStorage === 'undefined') {
            this.playerData = {
                isGuest: true,
                cameraStatus: false,
                microphoneStatus: false,
                gameId: gameId,
            };
            return;
        }

        let parsedData = JSON.parse(dataFromStorage);

        if (parsedData.gameId !== gameId) {
            this.playerData = {
                isGuest: true,
                cameraStatus: false,
                microphoneStatus: false,
                gameId: gameId,
            };
            return;
        }

        this.playerData = parsedData;
    }

    /**
     * Игрок является гостем
     */
    public getGuestStatus(): boolean
    {
        return this.playerData.isGuest;
    }

    /**
     * Изменить статус гостя
     * @param guestStatus
     */
    public setGuestStatus(guestStatus: boolean): void
    {
        this.playerData.isGuest = guestStatus;
        this.updateLocalStorage();
    }

    /**
     * Статус микрофона
     */
    public getMicrophoneStatus(): boolean
    {
        return this.playerData.microphoneStatus;
    }

    /**
     * Изменить статус микрофона
     * @param microphoneStatus
     */
    public setMicrophoneStatus(microphoneStatus: boolean): void
    {
        this.playerData.microphoneStatus = microphoneStatus;
        this.updateLocalStorage();
    }

    /**
     * Статус камеры
     */
    public getCameraStatus(): boolean
    {
        return this.playerData.cameraStatus;
    }

    /**
     * Установить статус камеры
     * @param cameraStatus
     */
    public setCameraStatus(cameraStatus: boolean): void
    {
        this.playerData.cameraStatus = cameraStatus;
        this.updateLocalStorage();
    }

    /**
     * Обновить данные в localStorage
     * @private
     */
    private updateLocalStorage(): void
    {
        localStorage.setItem('playerConferenceData', JSON.stringify(this.playerData))
    }
}
